export default __webpack_public_path__ + "04923ac6df7079158d6eec1273720754.ttf";